// extracted by mini-css-extract-plugin
module.exports = {"container":"store_container__STeS_","buy_button":"store_buy_button__2FxcJ","bottom_panel":"store_bottom_panel__OTglX","entry_description":"store_entry_description__2jFxW"};